import { render, staticRenderFns } from "./AttributesPanel.vue?vue&type=template&id=28700c52&scoped=true&"
import script from "./AttributesPanel.vue?vue&type=script&lang=js&"
export * from "./AttributesPanel.vue?vue&type=script&lang=js&"
import style0 from "./AttributesPanel.vue?vue&type=style&index=0&id=28700c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28700c52",
  null
  
)

export default component.exports